
<div :class="containerClass">
  <column class="d-flex">
    <slot name="value" v-if="!formulaText" :fieldName="fieldName" :model="getParent"></slot>
    <template v-else>
      <span class="text-truncate justify-self-start" :class="{'waiting-for-functionality': waitingForFunctionality}">
        Formula: {{truncatedFormulaText}}
      </span>
    </template>
    <slot name="button" :onClick="editFormula">
      <suffix class="justify-self-end" :class="{'waiting-for-functionality': waitingForFunctionality}">
        <div class="d-flex ml-1">
          <formula-button @click.self="editFormula" :disabled="disabled"/>
        </div>
      </suffix>
    </slot>
  </column>
  <formula-modal
    v-if="editedFormula"
    :dynamic-options="getDynamicOptions"
    :formula="editedFormula"
    :state="modalStateFor(vueModalID.formulaEditor)"
    :index="vueModalID.formulaEditor"
    @toggle-modal="hideFormulaModal"
    :form="form"
    :object-models="allObjectModels"
    @saved="(eventData) => $emit('saved', eventData)"
    @add-widget="addWidget"
  ></formula-modal>
</div>
